import { Token } from '@rimbu/base';
import { EmptyBase, } from '@rimbu/collection-types/map-custom';
import { OptLazy, OptLazyOr } from '@rimbu/common';
import { Stream } from '@rimbu/stream';
import { isEmptyStreamSourceInstance } from '@rimbu/stream/custom';
export class OrderedMapEmpty extends EmptyBase {
    constructor(context) {
        super();
        this.context = context;
    }
    get keyOrder() {
        return this.context.listContext.empty();
    }
    get sourceMap() {
        return this.context.mapContext.empty();
    }
    streamKeys() {
        return Stream.empty();
    }
    streamValues() {
        return Stream.empty();
    }
    hasKey() {
        return false;
    }
    get(key, otherwise) {
        return OptLazy(otherwise);
    }
    set(key, value) {
        return this.addEntry([key, value]);
    }
    addEntry(entry) {
        return this.context.createNonEmpty(this.context.listContext.of(entry[0]), this.context.mapContext.of(entry));
    }
    addEntries(entries) {
        if (isEmptyStreamSourceInstance(entries))
            return this;
        return this.context.from(entries);
    }
    modifyAt(key, options) {
        if (undefined === options.ifNew)
            return this;
        const value = OptLazyOr(options.ifNew, Token);
        if (Token === value)
            return this;
        return this.addEntry([key, value]);
    }
    removeKey() {
        return this;
    }
    removeKeys() {
        return this;
    }
    removeKeyAndGet() {
        return undefined;
    }
    mapValues() {
        return this;
    }
    updateAt() {
        return this;
    }
    toBuilder() {
        return this.context.builder();
    }
    toString() {
        return 'OrderedMap()';
    }
    toJSON() {
        return {
            dataType: this.context.typeTag,
            value: [],
        };
    }
}
//# sourceMappingURL=empty.mjs.map